import script from "./WidgetMediaControlsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetMediaControlsHeader.vue?vue&type=script&setup=true&lang=js"

import "./WidgetMediaControlsHeader.vue?vue&type=style&index=0&id=06bcdf7c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bcdf7c"]])

export default __exports__